module.exports = __webpack_public_path__ + "static/media/proj3.markdown.7128f9d2.md";